export enum AcquisitionRole {
  VIEWACQUISITION = 'viewacquisition',

  NOACCESS = 'noaccess',
  READWRITE = 'readwrite',
  READ = 'read',
}
